import type { FaireProductEntity } from "../../entity_types/product";

export const p_hdyjsgszee: FaireProductEntity = {
  token: "p_hdyjsgszee",
  type: "product",
  name: "Diana Collar Necklace",
  brandToken: "b_cn7om55jvr",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b25130e66eb98f0395b53c8d399b0884fa42144837266bb1db8b1f2539bd6c49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9608fb2a701d4edcdafee39294d8f0865bdc8b5a4e5ab6755c6ded5cb8f022d5.jpeg",
    "https://cdn.faire.com/fastly/8cd47b23539adacd5862605f24eac4424fbdff408e61d81bf8221736358600cf.jpeg",
    "https://cdn.faire.com/fastly/f9c02fd14297a2e5b4276c695350be59655814185ffeb354f5c76da2eab41c4c.jpeg",
    "https://cdn.faire.com/fastly/a4075e40a4a6399b00d7e8c2bd1372d306b7b58e2f26c9345546824c5d8291d6.jpeg",
    "https://cdn.faire.com/fastly/4ed5704d7fd8cdc85308d55f0360b8ded4d7c02fd10ee0fcc298d6f6a22bf9f5.jpeg",
    "https://cdn.faire.com/fastly/40f81e9d1f924c906fba1a2e213d36c5a72ec12f6e15c976ca2a4140f92bd0dd.jpeg",
    "https://cdn.faire.com/fastly/1101c77d5b4c62f1b2a220e9b168ee8f5e621943dd0328235a3066e188f6e6ab.jpeg",
    "https://cdn.faire.com/fastly/0710b996736d98cc7a2bb1c9438ab7eeb0eb6967c8d2acbb38205c24db6162cf.jpeg",
    "https://cdn.faire.com/fastly/e0ddf42bfa7eceb6847b214cdc2b851c5fc399348b965cc21346e6aa09c77a27.jpeg",
  ],
  priceDollars: 48.5,
  description:
    'This chunky necklace will meet all your statement jewellery needs. With crystal design, this white collar necklace is great for dressing up a simple look.  Crystal beads decorate and create a unique crystal design pattern on this classy collar necklace.    \n\nProduct Details:\n\nAlloy\nGlass crystal\nSize: 12" + 3" extension\nClosure: lobster clasp',
  tags: [],
  msrpDollars: 97,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:48.457Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
